import axios from 'axios'

const baseURL = 'https://api.opoint.com/'
const Repository = axios.create({
    baseURL
})

export default {
    getToken(username, password, rememberMe) {
        return Repository.post(`auth/get-token/`, {
            username: username,
            password: password,
            remember_me: rememberMe
        })
    }
}
